export default "__VITE_ASSET__tpNb3eUW__"